<template>
  <div class="form_step form_step-3 form-scroll" style="display: block">
    <form @submit.prevent="" id="step3">
      <input type="hidden" name="landing_type" value="cash">
      <div class="wrapper">
        <div class="wrapper__step-header">
          <button type="button"
                  @click.submit.prevent="goBack"
                  class="popup-button btn green-btn colored-btn">
            {{__t('Повернутись назад')}}
          </button>
          <form-header :load="'33%'"></form-header>
        </div>

        <div class="step-3_bookmarks-block">
          <div
            :class="{ 'bookmark-active' : passportType == 'old', 'step-3_bookmark' : true  }"
            @click="changePassport('old')" data-passport-type="old"
            tabindex="0"
            @keydown.enter.prevent="changePassport('old')"
            @keydown.space.prevent="changePassport('old')">
            <div class="bookmarks_title">
              <p>{{__t('Паспорт старого зразку')}}</p>
            </div>
          </div>
          <div class="step-3_bookmark"
               :class="{ 'bookmark-active' : passportType == 'id', 'step-3_bookmark' : true  }"
               @click="changePassport('id')" data-passport-type="id"
               tabindex="0"
               @keydown.enter.prevent="changePassport('id')"
               @keydown.space.prevent="changePassport('id')">
            <div class="bookmarks_title">
              <p>{{__t('ID картка')}}</p>
            </div>
          </div>
        </div>
        <div class="step-3_passport">
          <div class="step_passport-group">
            <div class="input-field">
              <label class="passport_seria" v-if="passportType == 'old'">
                <p>{{__t('Серія')}}</p>
                <div class="input-wrap">
                  <the-mask mask="FF" :tokens="hexTokens" type="text" name="client_series_passport"
                            placeholder="Серія"/>
                </div>
              </label>

              <label v-show="passportType == 'old'">
                <p>{{__t('Номер')}}</p>
                <div class="input-wrap">
                  <input type="tel" placeholder="Номер" name="client_number_passport"
                         v-mask="'######'">
                  <div class="input-info_btn">
                    <img src="/img/cash-credit-landing/info-btn.svg">
                    <div class="input-info_popup">
                      <p>{{__t('Подсказка для номера паспорта')}}</p>
                    </div>
                  </div>
                </div>
              </label>
              <label v-show="passportType == 'id'">
                <p>{{__t('Номер')}}</p>
                <div class="input-wrap">
                  <input type="tel" placeholder="Номер" name="client_number_passport_card" v-mask="'#########'">
                  <div class="input-info_btn">
                    <img src="/img/cash-credit-landing/info-btn.svg">
                    <div class="input-info_popup">
                      <p>{{__t('Подсказка для карты номера паспорта')}}</p>
                    </div>
                  </div>
                </div>
              </label>

            </div>
            <div class="input-field">
              <label>
                <p>{{__t('Коли виданий')}}</p>
                <div class="input-wrap">
                  <input type="tel" pattern="[0-9]*" name="passport_issue_date" placeholder="ДД.ММ.РРРР" @input="hideBackEndError"
                         v-mask="'##.##.####'">
                  <div v-show="typeof errorValidation.passport_issue_date !== 'undefined'">
                    <label class="error_back" style="color: red"
                           v-for="error in errorValidation.passport_issue_date">{{error}}</label>
                  </div>
                  <div class="input-info_btn">
                    <img src="/img/cash-credit-landing/info-btn.svg">
                    <div class="input-info_popup">
                      <p>{{__t('Подсказка для дата выдачи паспорта')}}</p>
                    </div>
                  </div>
                </div>
              </label>
            </div>
            <div class="input-field">
              <label>
                <p>{{__t('ІПН')}}</p>
                <div class="input-wrap">
                  <input type="tel" name="client_inn" v-model="ipn" placeholder="ІПН" :disabled="hasIPN" ref="ipn"
                         v-numericOnly v-mask="'##########'">
                  <div class="input-info_btn">
                    <img src="/img/cash-credit-landing/info-btn.svg">
                    <div class="input-info_popup">
                      <p>{{__t('Подсказка для ИПН')}}</p>
                    </div>
                  </div>
                </div>
              </label>
            </div>
            <div class="input-field input-checkbox">
              <label tabindex="0" @keydown.space.prevent="hasIPN = !hasIPN" @keydown.enter.prevent="hasIPN = !hasIPN">
                <div class="input-field_checkbox" :style="{background : hasIPN ? '#012748' : '#E8E8E8'}">
                  <img v-if="hasIPN" src="/img/cash-credit-landing/check.png">
                  <input type="checkbox" value="1" name="have_not_inn" v-model="hasIPN">
                </div>
                {{__t('Не маю ІПН')}}
              </label>
            </div>
            
          <!-- <div class="input-field">
            <label for="activities"><p>{{__t('Сімейний стан')}}</p>
              <div class="select-wrapper">
                <select name="marital" class="required activities">
                  <option value="">{{__t('Оберіть')}}</option>
                  <option :value="status.code" v-for="status in maritalstatus">{{status.title}}</option>
                </select>
                <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
              </div>
            </label>
          </div> -->
          </div>
        </div>
        <div class="input-group_title">
          <h4>{{__t('Адреса реєстрації')}}</h4>
        </div>
        <div class="step-3_address-block">
          <div class="step-3_address">
            <div class="step-address_wrap align-end fw">
              <div class="step-address_group fw">
                <div class="input-field">
                  <label>
                    <p>{{__t('Назва населеного пункту реєстрації')}}</p>
                    <div class="input-wrap">
                      <autocomplete
                        :search="searchCity1"
                        :getResultValue="getResultValue"
                        @submit="handleSubmit_1"
                        ref="autocomplete_1"
                        @blur="clearIfNotSelect"
                        v-autocomplete
                        :submitOnEnter="true"
                        @keydown.enter.native.stop.prevent
                        :placeholder="__t('Почніть вводити назву')">
                      </autocomplete>
                      <input type="hidden" name="autocomplete_1-id" ref="autocomplete_1_hidden">
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div class="input-field input-checkbox">
              <label tabindex="0" @keydown.space.prevent="liveAtAddress = !liveAtAddress" @keydown.enter.prevent="liveAtAddress = !liveAtAddress">
                <div class="input-field_checkbox" :style="{background : liveAtAddress ? '#012748' : '#E8E8E8'}">
                  <img v-if="liveAtAddress" src="/img/cash-credit-landing/check.png">
                  <input type="checkbox" name="fact" value="1" v-model="liveAtAddress">
                </div>
                {{__t('Фактично проживаю за адресою реєстрації')}}

              </label>
            </div>
          </div>
          <div class="step-3_address" v-show="!liveAtAddress">
            <div class="step-address_wrap align-end fw">
              <div class="step-address_group fw">
                <div class="input-field">
                  <label>
                    <p>{{__t('Назва населеного пункту')}}</p>
                    <div class="input-wrap ">
                      <autocomplete :search="searchCity2"
                                    :getResultValue="getResultValue"
                                    @blur="clearIfNotSelect"
                                    @submit="handleSubmit_2"
                                    ref="autocomplete_2"
                                    v-autocomplete
                                    :submitOnEnter="true"
                                    @keydown.enter.native.stop.prevent
                        :placeholder="__t('Почніть вводити назву')"></autocomplete>
                      <input type="hidden" name="autocomplete_2-id" ref="autocomplete_2_hidden">
                    </div>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="input-group_title">
          <h4>{{__t('Дані про членів родини')}}</h4>
        </div>
        <div class="version">
          <div class="form-wrap fw">
            <div class="input-field">
              <label for="marital"><p>{{__t('Сімейний стан')}}</p>
                <div class="select-wrapper">
                  <select name="marital" id="marital" class="required activities">
                    <option value="">{{__t('Оберіть')}}</option>
                    <option :value="status.code" v-for="status in maritalstatus">{{status.title}}</option>
                  </select>
                  <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                </div>
              </label>
            </div>
            <div class="input-field">
              <label for="count_of_members_family"><p>{{__t('Скільки членів родини проживає разом з вами?')}}</p>
                <div class="select-wrapper">
                  <select name="count_of_members_family" id="count_of_members_family" v-model="family_count" class="required activities">
                    <option value="">{{__t('Оберіть')}}</option>
                    <option :value="n" v-for="n in 11">{{n}}</option>
                  </select>
                  <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                </div>
              </label>
            </div>
            <div class="input-field">
              <label for="count_of_workers_members_family"><p>{{__t('Скільки з них працює?')}}</p>
                <div class="select-wrapper">
                  <select name="count_of_workers_members_family" id="count_of_workers_members_family" class="required activities">
                    <option value="">{{__t('Оберіть')}}</option>
                    <option :value="n" v-for="n in (family_count)">{{n}}</option>
                  </select>
                  <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
                </div>
              </label>
            </div>
            <div class="input-field">
              <label for="client_phone_neighbors">
                <p>{{__t('Номер телефону контактної особи')}}</p>
                <input type="tel" name="client_phone_neighbors" id="client_phone_neighbors" placeholder="Номер телефону" v-mask="'+380(##) ###-####'">
                <div v-show="typeof errorValidation.client_phone_neighbors !== 'undefined'">
                  <label class="error_back" style="color: red"
                         v-for="error in errorValidation.client_phone_neighbors">{{error}}</label>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="step-3_apartment fw">
        <div class="input-field">
          <label>
            <p>{{__t('Це ваше житло?')}}</p>
            <div class="select-wrapper input-wrap">
              <select name="status_accomodation" id="" class="required activities">
                <option value="default">{{__t('Умови проживання')}}</option>
                <option :value="status.code" v-for="status in housingstatus">{{status.title}}
                </option>
              </select>
              <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>
            <p>{{__t('Коли почали тут жити?')}}</p>
            <div class="select-wrapper input-wrap">
              <select name="apartment_month">
                <option value="default">{{__t('Місяць')}}</option>
                <option :value="index+1" v-for="(item, index) in months" :key="index">{{item}}</option>
              </select>
              <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
            </div>
          </label>
        </div>
        <div class="input-field">
          <label>

            <div class="input-wrap">
              <input type="tel" :placeholder="__t('Рік')" name="apartment_year" v-mask="'####'">
            </div>
          </label>
        </div>
      </div> -->

      <div class="button-group">
        <button type="button"
                @click.submit.prevent="goBack"
                class="popup-button btn green-btn colored-btn">
          {{__t('Повернутись назад')}}
        </button>
        <div class="button-wrapper page-bottom ">
          <button type="submit" class="single-button btn violet-btn">{{__t('Далі')}}</button>
        </div>
      </div>

    </form>
  </div>
</template>

<script>
    import axios from 'axios'

    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'
    import moment from 'moment';

    export default {
        name: "step3",
        components: {
            Autocomplete
        },
        props: [
            'maritalstatus',
            'housingstatus',
            'client_birthday',
            'type_activity',
            'client_ipn'
        ],
        data() {
            return {
                passportType: 'old',
                hasIPN: false,
                ipn: this.client_ipn,
                allRight: false,
                liveAtAddress: false,
                autocompleteSelected_1: true,
                autocompleteSelected_2: true,
                months: [
                    "Січень",
                    "Лютий",
                    "Березень",
                    "Квітень",
                    "Травень",
                    "Червень",
                    "Липень",
                    "Серпень",
                    "Вересень",
                    "Жовтень",
                    "Листопад",
                    "Грудень"
                ],
                hexTokens: {
                    F: {
                        pattern: /[а-щА-ЩЬьЮюЯяЇїІіЄєҐґ]/,
                        transform: v => v.toLocaleUpperCase()
                    }
                },
                errorValidation : {},
                family_count: '',

            }
        },
        mounted() {


            $(".autocomplete input").each(function (index) {
                $(this).prop("name", `autocomplete${index + 1}`)
            });
            this.validation();


            $('.input-info_btn').on('mouseover', function (el) {
                this.querySelector('.input-info_popup').style.visibility = "visible";
            });


            $('.input-info_btn').on('mouseout', function (el) {
                this.querySelector('.input-info_popup').style.visibility = "hidden";
            });


        },
        computed: {
            paintBox() {
                return this.hasIPN ? '#012748' : '#E8E8E8';
            },

        },
        watch:{
            hasIPN(){
                if(this.hasIPN){
                    $('input[name="client_inn"]').removeClass("error");
                    $('#client_inn-error').remove();

                    this.ipn = '';
                }
            }
        },

        methods: {
            __t(phrase) {
                return window.__t(phrase);
            },
            clearIfNotSelect(){
                if( this.autocompleteSelected_1 ){
                    this.$refs.autocomplete_1.value = "";
                }
                if( this.autocompleteSelected_2 ){
                    this.$refs.autocomplete_2.value = "";
                }
            },
            hideBackEndError(el){
               this.errorValidation.passport_issue_date = [];
            },
            doRequest() {
                var self = this;
                var data = $('#step3').serializeArray();

                self.$emit('openPreloader');

                jQuery.ajax({
                  headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                  },
                    data: data,
                    type: "POST",
                    url: '/cash/step3',
                    cache: false,
                    dataType: "json",
                    success: function (response) {
                        if(self.type_activity == 11){
                            self.$emit('gonext');
                            self.$emit('closePreloader');
                        }else{
                            self.goNext();
                            self.$emit('closePreloader');
                        }

                    },
                    error: function (error) {

                        self.errorValidation = error.responseJSON;
                        self.$emit('closePreloader');
                    }
                });
            },
            doAllRight() {
                this.allRight = true;
                this.doRequest();
            },
            setIpn(e) {
                this.ipn = e;
            },
            parseUaID(ipn) {

                let split = ipn.split('');

                let summ = +split[0] * (-1) + +split[1] * 5 + +split[2] * 7 + +split[3] * 9 + +split[4] * 4 + +split[5] * 6 + +split[6] * 10 + +split[7] * 5 + +split[8] * 7;

                let control = (summ - (11 * Math.floor(summ / 11)));

                if (control == 10){
                    control = 0;
                }

                let status = (control == +split[9]) ? true : false;
                // true if  inn is existing

                if(status){

                let pathOfIPN = +ipn.substr(0, 5);
                let startDate = '01.01.1900';

                var new_date = moment(startDate, "DD-MM-YYYY").add(--pathOfIPN, "days");

                let birthday = {
                    day: new_date.format('DD'),
                    month: new_date.format('MM'),
                    year: new_date.format('YYYY')
                };

                return birthday;

                }else{
                    return false;
                }

            },
            async searchCity1(input) {
                this.autocompleteSelected_1 = true;
                let result;
                if (input.length <= 1) {
                    return [];
                }

                let axiosConf = {
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
                };
                await axios.post('/cash/search-city', JSON.stringify(input), axiosConf)
                    .then(response => {

                        result = response.data;
                    });

                return result;

            },
            async searchCity2(input) {
                this.autocompleteSelected_2 = true;
                let result;
                if (input.length <= 1) {
                    return [];
                }

                let axiosConf = {
                    headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}
                };
                await axios.post('/cash/search-city', JSON.stringify(input), axiosConf)
                    .then(response => {

                        result = response.data;
                    });

                return result;

            },
            getResultValue(result) {
                return result[Object.keys(result)]
            },
            handleSubmit_1(result) {
                this.autocompleteSelected_1 = false;
                this.$refs.autocomplete_1_hidden.value = Object.keys(result);
            },
            handleSubmit_2(result) {
                this.autocompleteSelected_2 = false;
                this.$refs.autocomplete_2_hidden.value = Object.keys(result);
            },
            goBack() {
                this.$emit('goback');
                return false;
            },
            goNext() {

                // if (this.type_activity == 11) { // 11 - Власне підсобне господарство
                //     this.$emit('changeStep', 5);
                //     return false;
                // }

                this.$emit('gonext');
                return false;
            },
            changePassport(type) {
                this.passportType = type;
            },
            validation: function () {
                let that = this;

                $.validator.addMethod("mobileValidate", function (value, element, arg) {
                  if (value) {
                    const phoneCodes = [
                      '039','050','053','067','063','066','068','073','075','077',
                      '091','092','093','094','095','096','097','098','099',
                    ];
                    const phoneWithCode = value.replace(/[^0-9+]/g, '');
                    let clearPhone, code;
                    if (/^\+38/gi.test(phoneWithCode)) {
                      code = phoneWithCode.slice(3, 6);
                      clearPhone = phoneWithCode.slice(6);
                    } else {
                      code = phoneWithCode.slice(0, 3);
                      clearPhone = phoneWithCode.slice(3);
                    }
                    return clearPhone.length === 7 && phoneCodes.includes(code);
                  }
                  return false;
                }, 'Некоректний формат номеру телефона');

                $('#step3').validate({
                    rules: {
                        // marital: {
                        //     required: true
                        // },
                        client_series_passport: {
                            required: true,
                            minlength: 2,
                            maxlength: 2,
                        },
                        client_number_passport: {
                            required: true,
                            minlength: 6,
                            maxlength: 6,

                        },
                        client_number_passport_card: {
                            required: true,
                            minlength: 9,
                            maxlength: 9,
                            number: true,
                        },
                        client_inn: {
                            number: true,
                            required: true,
                            minlength: 10,
                        },
                        passport_issue_date: {
                            required: true,
                            regDay: true,
                        },
                        address_registration_city: {
                            required: true,
                        },
                        fact_address_registration_city: {
                            required: true,
                        },
                        address_registration_street: {
                            required: true,
                            maxlength: 50
                        },
                        fact_address_registration_street: {
                            required: true,
                            maxlength: 50
                        },
                        address_registration_house_id: {
                            required: true,
                            maxlength: 10,
                        },
                        fact_address_registration_house_id: {
                            required: true,
                            maxlength: 10,
                        },
                        status_accomodation: {
                            selectRequired: 'default'
                        },
                        apartment_month: {
                            selectRequired: 'default',
                            apartmentDate: true
                        },
                        apartment_year: {
                            required: true,
                            regDay: true,
                        },
                        autocomplete1: {
                            required: true
                        },
                        autocomplete2: {
                            required: true
                        },
                        marital: {
                            required: true
                        },
                        count_of_members_family: {
                            required: true
                        },
                        count_of_workers_members_family: {
                            required: true
                        },
                        client_phone_neighbors: {
                            required: true,
                            minlength: 17,
                            maxlength: 17,
                            mobileValidate: true,
                        },

                    },
                    messages: {
                        // marital: {
                        //     required: "Заповніть поле",
                        // },
                        client_series_passport: {
                            required: __t("Заповніть поле"),
                            pattern: __t("Це поле может содержать тiльки лiтери"),
                            minlength: __t("Це поле мае бути из 2 цифр"),
                            maxlength: __t("Це поле мае бути из 2 цифр"),
                        },
                        client_number_passport: {
                            required: __t("Заповніть поле"),
                            minlength: __t("Це поле мае бути из 6 цифр"),
                            maxlength: __t("Це поле мае бути из 6 цифр"),
                        },
                        client_number_passport_card: {
                            required: __t("Заповніть поле"),
                            minlength: __t("Це поле мае бути из 9 цифр"),
                            maxlength: __t("Це поле мае бути из 9 цифр"),
                        },
                        client_inn: {
                            required: __t("Заповніть поле"),
                            number: __t("Тiльки цифри"),
                            minlength: __t("Це поле мае бути из 10 цифр"),

                        },
                        passport_issue_date: {
                            required: __t("Заповніть поле"),

                        },
                        address_registration_city: {
                            required: __t("Заповніть поле"),
                        },
                        fact_address_registration_city: {
                            required: __t("Заповніть поле"),
                        },
                        address_registration_street: {
                            required: __t("Заповніть поле"),
                            maxlength: __t("Не більше 50 символiв"),
                        },
                        fact_address_registration_street: {
                            required: __t("Заповніть поле"),
                            maxlength: __t("Не більше 50 символiв"),
                        },
                        address_registration_house_id: {
                            required: __t("Заповніть поле"),
                             maxlength: __t("Не більше 10 символiв"),
                        },
                        fact_address_registration_house_id: {
                            required: __t("Заповніть поле"),
                            maxlength: __t("Не більше 10 символiв"),
                        },
                        apartment_year: {
                            required: __t("Заповніть поле")
                        },

                        apartment_month: {
                            selectRequired: __t("Оберіть місяць")
                        },
                        status_accomodation: {
                            selectRequired: __t("Оберіть один з варіантів")
                        },
                        autocomplete1: {
                            required: __t("Заповніть поле"),
                            minlength: __t("Заповніть поле"),
                        },
                        autocomplete2: {
                            required: __t("Заповніть поле"),
                            minlength: __t("Заповніть поле"),
                        },
                        marital: {
                            required: "Заповніть поле",
                        },
                        count_of_members_family: {
                            required: "Заповніть поле",
                        },
                        count_of_workers_members_family: {
                            required: "Заповніть поле",
                        },
                        client_phone_neighbors: {
                            required: __t("Це поле обов’язкове. Заповніть його"),
                            minlength: __t('Номер телефону складається з 12 цифр'),
                            maxlength: __t('Номер телефону складається з 12 цифр'),
                            mobileValidate: __t('Некоректний формат номеру телефона'),
                        }

                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                    },
                    submitHandler: function (form) {

                        if (!that.hasIPN) {

                            let birstday = that.parseUaID(that.$refs.ipn.value);
                            let bd = that.client_birthday.split('.');

                            if (that.allRight) {
                                that.doRequest();
                            } else if (!that.hasIPN) {
                                if (birstday.day == bd[0] && birstday.month == bd[1] && birstday.year == bd[2]) {
                                    that.doRequest();
                                } else {
                                    that.$emit("openIpnPopup", that.$refs.ipn.value)
                                }
                            }

                        } else {
                            that.doRequest();
                        }


                    }
                });

            },

        }

    }



</script>

<style>
.step-3_address-block {
  display: flex;
  gap: 26px;
  justify-content: space-between;
}
.step-3_address-block .step-3_address {
  max-width: 50%;
  flex: 0 0 47%;
}
@media (max-width: 768px) {
  .step-3_address-block {
    display: block;
  }
  .step-3_address-block .step-3_address {
    max-width: initial;
  }
}
</style>